import React from "react";
import WorkpageCard from "../AllWork/WorkpageCard";
import Link from "../../../utils/link";

const RelatedProjects = (projects) => {

   if (projects.projects.length == 0 || projects.projects == undefined ) return null

    return (
        <section className="width pb-12 lg:pb-16">
            <h2 className="text-lg lg:text-3xl font-semibold pb-5 lg:pb-7 pt-4 lg:pt-0 border-t border-black lg:border-t-0">
                Related projects.
            </h2>
            <ol className="grid lg:grid-cols-2 gap-7 lg:gap-6">
                {
                    projects.projects.map(project => {
                        const content = project.content
                        
                        if (content?.card_image?.filename == undefined || content?.card_image?.filename == '') return null

                        return (
                            <li key={`related-project-${project.uuid}`}>
                                <WorkpageCard image={content.card_image} video={project.content.card_video} title={content.title} copy={content.tagline} url={`${project.full_slug}`} mobileLandscape />
                            </li>
                        )
                    })
                }

                <li className="lg:hidden">
                    <Link className='uppercase text-center bg-white border w-full border-green inline-block pt-4 pb-3' to="/work/">
                    See more work
                    </Link>
                </li>

            </ol>

        </section>
    )
}

export default RelatedProjects